import {
	Panel,
	PanelBody,
	PanelRow,
	TextControl,
	TextareaControl,
	CheckboxControl,
	Button,
	withFocusOutside,
} from "@wordpress/components"
import { registerPlugin } from "@wordpress/plugins"
import { PluginSidebar, PluginSidebarMoreMenuItem } from "@wordpress/edit-post"
import { __ } from "@wordpress/i18n"
import { select, withSelect, withDispatch } from "@wordpress/data"
import { compose } from "@wordpress/compose"
import { useState, useEffect } from "@wordpress/element"

const relevanssiIcon = wp.element.createElement(
	"svg",
	{
		width: 20,
		height: 20,
	},
	wp.element.createElement("path", {
		d: "M5.644 20.665 C6.207 20.545 6.612 20.029 6.574 19.438 6.469 17.784 6.492 16.554 6.617 15.602 L7.388 19.228 C7.454 19.538 7.576 19.815 7.737 20.058 7.742 20.12 7.749 20.181 7.763 20.243 L8.444 23.384 C10.112 23.233 11.311 22.775 11.214 23.077 L10.82 21.227 C10.875 21.218 10.929 21.211 10.984 21.199 10.995 21.197 11.004 21.193 11.015 21.191 L11.35 22.766 C11.571 22.305 13.613 22.092 14.187 21.891 L13.42 19.11 C13.529 18.742 13.553 18.346 13.466 17.936 L12.445 13.134 C12.535 13.088 12.62 13.03 12.698 12.959 12.737 12.929 12.786 12.899 12.84 12.864 13.25 12.596 14.097 12.042 14.433 10.839 L20.429 12.98 C20.642 13.056 20.862 13.067 21.069 13.023 21.456 12.941 21.792 12.667 21.934 12.267 22.154 11.655 21.835 10.981 21.222 10.763 L14.393 8.324 C14.385 8.291 14.379 8.26 14.37 8.226 14.212 7.595 13.573 7.212 12.94 7.372 12.887 7.385 12.838 7.402 12.789 7.422 12.873 6.845 12.859 6.245 12.731 5.643 12.145 2.884 9.422 1.118 6.661 1.705 3.901 2.292 2.132 5.012 2.718 7.771 3.304 10.529 6.027 12.295 8.788 11.708 10.041 11.442 11.088 10.735 11.805 9.786 11.917 9.894 12.05 9.981 12.203 10.04 12.148 10.37 11.997 10.56 11.811 10.71 10.72 11.467 10.238 11.826 9.318 12.07 L8.678 12.167 C7.581 12.344 6.407 12.307 5.457 11.871 4.141 13.689 3.972 15.683 4.221 19.589 4.263 20.238 4.823 20.73 5.473 20.688 5.531 20.685 5.589 20.677 5.644 20.665 Z M8.568 10.67 C6.38 11.135 4.222 9.735 3.758 7.55 3.293 5.364 4.695 3.208 6.883 2.743 9.07 2.278 11.229 3.677 11.693 5.863 12.158 8.049 10.755 10.205 8.568 10.67 Z",
	}),
	wp.element.createElement("path", {
		d: "M8.009 5.745 C7.25 5.906 6.576 5.754 6.502 5.406 6.496 5.377 6.496 5.348 6.498 5.318 6.012 5.752 5.765 6.429 5.911 7.115 6.127 8.132 7.122 8.783 8.132 8.568 9.142 8.353 9.786 7.354 9.57 6.338 9.483 5.928 9.269 5.58 8.98 5.323 8.755 5.503 8.411 5.66 8.009 5.745 Z",
	})
)

const { Fragment } = wp.element

registerPlugin("relevanssi-premium", {
	render: function () {
		const [relevanssiSees, setRelevanssiSees] = useState([])
		const [relevanssiRelated, setRelevanssiRelated] = useState([])
		const [relevanssiExcluded, setRelevanssiExcluded] = useState([])
		const [relevanssiExcludedIds, setRelevanssiExcludedIds] = useState([])
		const [relevanssiCommonTerms, setRelevanssiCommonTerms] = useState([])
		const [relevanssiLowRankingTerms, setRelevanssiLowRankingTerms] = useState(
			[]
		)

		const regenerateRelatedPosts = (postId, metaKey, metaValue) => {
			if (!metaValue) metaValue = "0"
			wp.apiFetch({
				path: `/relevanssi/v1/regeneraterelatedposts/${postId}/${metaKey}/${metaValue}`,
			}).then((data) => {
				setRelevanssiRelated(createRelatedList(data))
			})
		}

		const RelatedPostControl = withFocusOutside(
			class extends React.Component {
				handleFocusOutside() {
					regenerateRelatedPosts(
						wp.data.select("core/editor").getCurrentPostId(),
						this.props.metaKey,
						wp.data.select("core/editor").getEditedPostAttribute("meta")[
							this.props.metaKey
						]
					)
				}

				render() {
					return (
						<MetaControl
							control={this.props.control}
							title={this.props.title}
							metaKey={this.props.metaKey}
						></MetaControl>
					)
				}
			}
		)

		const MetaControl = compose(
			withDispatch((dispatch, props) => {
				return {
					setMetaValue: function (metaValue) {
						dispatch("core/editor").editPost({
							meta: { [props.metaKey]: metaValue },
						})
					},
				}
			}),
			withSelect((select, props) => {
				let metaValue =
					select("core/editor").getEditedPostAttribute("meta")[props.metaKey]
				if (metaValue === "0") metaValue = ""
				return {
					metaValue,
				}
			})
		)((props) => {
			let args = {
				label: props.title,
				value: props.metaValue,
				onChange: function (content) {
					props.setMetaValue(content)
				},
			}
			if (props.control == CheckboxControl) {
				const checked = props.metaValue == "on" ? true : false
				args.value = ""
				args.checked = checked
				args.onChange = function (content) {
					content = content ? "on" : "off"
					props.setMetaValue(content)
				}
			}
			return wp.element.createElement(props.control, args)
		})

		const excludeRelatedPost = (excludedPostId, postId) => {
			wp.apiFetch({
				path: `/relevanssi/v1/excluderelatedpost/${excludedPostId}/${postId}`,
			}).then((data) => {
				setRelevanssiExcludedIds(data)
			})
		}

		const unExcludeRelatedPost = (excludedPostId, postId) => {
			wp.apiFetch({
				path: `/relevanssi/v1/unexcluderelatedpost/${excludedPostId}/${postId}`,
			}).then((data) => {
				setRelevanssiExcludedIds(data)
			})
		}

		const postId = select("core/editor").getCurrentPostId()
		useEffect(() => {
			wp.apiFetch({
				path: `/relevanssi/v1/sees/${postId}`,
			}).then((data) => {
				setRelevanssiSees(data)
			})
		}, [postId])

		/*<MetaButton excludedPostId={row.id} postId={postId} />


							*/

		const createRelatedList = (data) => {
			return data.map((row) => {
				return (
					<li key={row.id}>
						<a href={row.link}>{row.title}</a>{" "}
						<Button onClick={() => excludeRelatedPost(row.id, postId)}>
							({__("not this", "relevanssi")})
						</Button>
					</li>
				)
			})
		}
		useEffect(() => {
			wp.apiFetch({
				path: `/relevanssi/v1/listrelated/${postId}`,
			}).then((data) => {
				setRelevanssiRelated(createRelatedList(data))
			})
		}, [postId, relevanssiExcludedIds])

		useEffect(() => {
			wp.apiFetch({
				path: `/relevanssi/v1/listexcluded/${postId}`,
			}).then((data) => {
				const list = data.map((row) => {
					return (
						<li key={row.id}>
							<a href={row.link}>{row.title}</a>
							<Button onClick={() => unExcludeRelatedPost(row.id, postId)}>
								({__("use this", "relevanssi")})
							</Button>
						</li>
					)
				})
				setRelevanssiExcluded(list)
			})
		}, [postId, relevanssiExcludedIds])

		const createTermsList = (data) => {
			return data.map((row) => {
				return (
					<li key={row.id}>
						{row.query} ({row.count})
					</li>
				)
			})
		}
		useEffect(() => {
			wp.apiFetch({
				path: `/relevanssi/v1/listinsightscommon/${postId}`,
			}).then((data) => {
				setRelevanssiCommonTerms(createTermsList(data))
			})
		}, [postId])
		useEffect(() => {
			wp.apiFetch({
				path: `/relevanssi/v1/listinsightslowranking/${postId}`,
			}).then((data) => {
				setRelevanssiLowRankingTerms(createTermsList(data))
			})
		}, [postId])

		return (
			<Fragment>
				<PluginSidebarMoreMenuItem
					target="relevanssi-premium"
					icon={relevanssiIcon}
				>
					Relevanssi Premium
				</PluginSidebarMoreMenuItem>
				<PluginSidebar
					name="relevanssi-premium"
					icon={relevanssiIcon}
					title="Relevanssi Premium"
				>
					<Panel>
						<PanelBody
							initialOpen={false}
							title={__("How Relevanssi sees this post", "relevanssi")}
						>
							{relevanssiSees.title && (
								<p>
									<strong>{__("Title:", "relevanssi")}</strong>
									<br />
									{relevanssiSees.title}
								</p>
							)}
							{relevanssiSees.content && (
								<p>
									<strong>{__("Content:", "relevanssi")}</strong>
									<br />
									{relevanssiSees.content}
								</p>
							)}
							{relevanssiSees.author && (
								<p>
									<strong>{__("Author:", "relevanssi")}</strong>
									<br />
									{relevanssiSees.author}
								</p>
							)}
							{relevanssiSees.category && (
								<p>
									<strong>{__("Categories:", "relevanssi")}</strong>
									<br />
									{relevanssiSees.category}
								</p>
							)}
							{relevanssiSees.tag && (
								<p>
									<strong>{__("Tags:", "relevanssi")}</strong>
									<br />
									{relevanssiSees.tag}
								</p>
							)}
							{relevanssiSees.taxonomy && (
								<p>
									<strong>{__("Other taxonomies:", "relevanssi")}</strong>
									<br />
									{relevanssiSees.taxonomy}
								</p>
							)}
							{relevanssiSees.comment && (
								<p>
									<strong>{__("Comments:", "relevanssi")}</strong>
									<br />
									{relevanssiSees.comment}
								</p>
							)}
							{relevanssiSees.customfield && (
								<p>
									<strong>{__("Custom fields:", "relevanssi")}</strong>
									<br />
									{relevanssiSees.customfield}
								</p>
							)}
							{relevanssiSees.excerpt && (
								<p>
									<strong>{__("Excerpt:", "relevanssi")}</strong>
									<br />
									{relevanssiSees.excerpt}
								</p>
							)}
							{relevanssiSees.link && (
								<p>
									<strong>{__("Links to this post:", "relevanssi")}</strong>
									<br />
									{relevanssiSees.link}
								</p>
							)}
							{relevanssiSees.mysql && (
								<p>
									<strong>{__("MySQL columns:", "relevanssi")}</strong>
									<br />
									{relevanssiSees.mysql}
								</p>
							)}
							{relevanssiSees.reason && (
								<p>
									<strong>
										{__("Reason this post is not indexed:", "relevanssi")}
									</strong>
									<br />
									{relevanssiSees.reason}
								</p>
							)}
						</PanelBody>
					</Panel>
					<Panel>
						<PanelBody initialOpen={false} title={__("Pinning", "relevanssi")}>
							<PanelRow>
								<MetaControl
									control={CheckboxControl}
									title={__(
										"Pin this post for all searches it appears in.",
										"relevanssi"
									)}
									metaKey="_relevanssi_pin_for_all"
								></MetaControl>
							</PanelRow>
							<PanelRow>
								<MetaControl
									control={TextareaControl}
									title={__(
										"A comma-separated list of single word keywords or multi-word phrases.",
										"relevanssi"
									)}
									metaKey="_relevanssi_pin_keywords"
								></MetaControl>
							</PanelRow>
							<PanelRow>
								<p>
									{__("If any of these keywords are present in the search query, this post will be moved on top of the search results.", "relevanssi")}
								</p>
							</PanelRow>
							<PanelRow>
								<p>
									{__("You can add weights to pinned keywords like this: 'keyword (100)'. The post with the highest weight will be sorted first if there are multiple posts pinned to the same keyword.", "relevanssi")}
								</p>
							</PanelRow>
						</PanelBody>
						<PanelBody
							initialOpen={false}
							title={__("Exclusion", "relevanssi")}
						>
							<PanelRow>
								<MetaControl
									control={CheckboxControl}
									title={__(
										"Exclude this post or page from the index.",
										"relevanssi"
									)}
									metaKey="_relevanssi_hide_post"
								></MetaControl>
							</PanelRow>
							<PanelRow>
								<MetaControl
									control={CheckboxControl}
									title={__(
										"Ignore post content in the indexing.",
										"relevanssi"
									)}
									metaKey="_relevanssi_hide_content"
								></MetaControl>
							</PanelRow>
							<PanelRow>
								<MetaControl
									control={TextareaControl}
									title={__(
										"A comma-separated list of single word keywords or multi-word phrases.",
										"relevanssi"
									)}
									metaKey="_relevanssi_unpin_keywords"
								></MetaControl>
							</PanelRow>
							<PanelRow>
								<p>
									{__("If any of these keywords are present in the search query, this post will be removed from the search results.", "relevanssi" )}
								</p>
							</PanelRow>
						</PanelBody>
					</Panel>
					<Panel>
						<PanelBody
							initialOpen={false}
							title={__("Related posts", "relevanssi")}
						>
							<PanelRow>
								<MetaControl
									control={CheckboxControl}
									title={__(
										"Don't append the related posts to this page.",
										"relevanssi"
									)}
									metaKey="_relevanssi_related_no_append"
								></MetaControl>
							</PanelRow>
							<PanelRow>
								<MetaControl
									control={CheckboxControl}
									title={__(
										"Don't show this as a related post for any post.",
										"relevanssi"
									)}
									metaKey="_relevanssi_related_not_related"
								></MetaControl>
							</PanelRow>
							<PanelRow>
								<RelatedPostControl
									control={TextareaControl}
									title={__(
										"A comma-separated list of keywords to use for the Related Posts feature.",
										"relevanssi"
									)}
									metaKey="_relevanssi_related_keywords"
								/>
							</PanelRow>
							<PanelRow>
								<p>
									{__("Anything entered here will used when searching for related posts. Using phrases with quotes is allowed, but will restrict the related posts to posts including that phrase.", "relevanssi")}
								</p>
							</PanelRow>
							<PanelRow>
								<RelatedPostControl
									control={TextControl}
									title={__(
										"A comma-separated list of post IDs to use as related posts for this post",
										"relevanssi"
									)}
									metaKey="_relevanssi_related_include_ids"
								/>
							</PanelRow>
							<p>{__("Related posts for this post:", "relevanssi")}</p>
							<ol>{relevanssiRelated}</ol>

							<p>{__("Excluded posts for this post:", "relevanssi")}</p>
							<ol>{relevanssiExcluded}</ol>
						</PanelBody>
					</Panel>
					<Panel>
						<PanelBody initialOpen={false} title={__("Insights", "relevanssi")}>
							<p>
								{__(
									"The most common search terms used to find this post:",
									"relevanssi"
								)}
							</p>
							<ol>{relevanssiCommonTerms}</ol>
							<p>
								{__(
									"Low-ranking search terms used to find this post:",
									"relevanssi"
								)}
							</p>
							<ol>{relevanssiLowRankingTerms}</ol>
						</PanelBody>
					</Panel>
				</PluginSidebar>
			</Fragment>
		)
	},
})
